import { render, staticRenderFns } from "./Retrievepasswordd.vue?vue&type=template&id=c88d8766&scoped=true&"
import script from "./Retrievepasswordd.vue?vue&type=script&lang=js&"
export * from "./Retrievepasswordd.vue?vue&type=script&lang=js&"
import style0 from "./Retrievepasswordd.vue?vue&type=style&index=0&id=c88d8766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88d8766",
  null
  
)

export default component.exports